import { makeStyles } from '@material-ui/core/styles';
import { Link } from '@/components/global';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles(({ breakpoints: BP }) => ({
  card: {
    display: 'flex',
    height: '100%',
    borderRadius: 10,
    fontSize: 15,
    boxShadow: '0 3px 6px 0 rgb(0 0 0 / 16%)',
    backgroundSize: 'cover !important',
    background: ({ img }) => `url('${img}') no-repeat center`,
    transition: 'all 0.2s ease-in-out',

    '& span': {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 10,
      color: '#fff',
      transition: 'all 0.2s ease-in-out',
      backgroundColor: '#40312e',
      opacity: 0.76,
    },

    [BP.down('xs')]: {
      fontSize: 10,
      height: '10vh',
    },
    '&:hover': {
      transform: 'scale(1.07)',
      '& span': {
        backgroundColor: '#53b9b6',
      },
    },
  },
}));

export default function BlogCard({ item = {} }) {
  const cls = useStyles({ img: item.img });
  return (
    <Grid item xs={4} className={cls.img}>
      <Link href={`/category/${item.id}`} className={cls.card}>
        <span>{item.title}</span>
      </Link>
    </Grid>
  );
}
